// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3048W","header":"PatientQuestionnaire_header__16BLo","info":"PatientQuestionnaire_info__bE1Y7"};